import { IChannel, IProduct } from '../models';
import { getIncludedResource } from '../util';

export function fromJsonApi(data, included: any[]): IChannel {
  const {
    name,
    channel_type: channelType,
    key,
    whitelabel,
    metadata,
  } = data.attributes;

  const products = getIncludedResource(data, included, 'products', true).map((resource): IProduct => {

    const schemeDocuments = [];
    getIncludedResource(resource, included, 'schemes', true).forEach((schemeResource) => {
      getIncludedResource(schemeResource, included, 'documents', true).forEach((docResource) => {
        schemeDocuments.push(docResource);
      });
    });

    const {
      name,
      product_type: productType,
      product_code: productCode,
      status,
      summary,
      description,
      icon,
      metadata,
      documents,
    } = resource.attributes;

    return {
      id: resource.id,
      name,
      productType,
      productCode,
      status,
      summary,
      description,
      icon,
      metadata,
      schemes: [],
      documents,
      schemeDocuments,
    };
  });
  return {
    id: data.id,
    name,
    showRenewalTab: metadata.show_renewal_tab,
    channelType,
    key,
    whitelabel,
    products,
    baseName: metadata.base_name,
    offlineSchedule: metadata.offline_schedule,
    phone: metadata.phone,
    email: metadata.email,
    footer: metadata.footer,
    openingHours: metadata.opening_hours,
    steps: metadata.steps,
  };
}
